import { FC } from 'react';

import { recordForceUpdateAttempt } from '../../../utils/force-update-util';
import RectButton from '../Button/RectButton';
import classes from './ForceUpdateModal.module.scss';
import ModalContainer from './ModalContainer';

interface ForceUpdateModalProps {
  isOpen: boolean;
}

const ForceUpdateModal: FC<ForceUpdateModalProps> = ({ isOpen }) => {
  const handleReload = async () => {
    // 강제 업데이트 시도 기록 (3회 이상 시 자동으로 console.log 출력)
    await recordForceUpdateAttempt();
    window.location.reload();
  };

  return (
    <ModalContainer isOpen={isOpen} transparent>
      <div className={classes.forceUpdateModal}>
        <div className={classes.forceUpdateContent}>
          <div className={classes.forceUpdateIcon}>
            <span>🔄</span>
          </div>
          <h2 className={classes.forceUpdateTitle}>업데이트가 필요합니다</h2>
          <p className={classes.forceUpdateMessage}>
            더 나은 서비스 제공을 위해
            <br />
            최신 버전으로 업데이트해주세요.
          </p>
          <RectButton label='새로고침' onClick={() => void handleReload()} className={classes.forceUpdateButton} />
        </div>
      </div>
    </ModalContainer>
  );
};

export default ForceUpdateModal;
